module.exports = __webpack_public_path__ + "img/Variety.e1796a1c.jpeg";